<template>
  <div>
    <v-row>
      <v-col class="flex-grow-0">
        <KpiSingleComponent v-bind="kpis[0]"/>
      </v-col>
      <v-col>
        <KpiSingleComponent v-bind="kpis[1]"/>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="flex-grow-0">
        <KpiSingleComponent clickable v-bind="kpis[2]" @clicked="onKpiClicked(kpis[2])"/>
      </v-col>
      <v-col>
        <KpiSingleComponent v-bind="kpis[3]">
          <KpiDropdownComponent/>
        </KpiSingleComponent>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import KpiSingleComponent from "@/components/lead/kpi/KpiSingleComponent";
import {trendDirections, colors} from "@/components/lead/kpi/KpiSingleComponent";
import KpiDropdownComponent from "@/components/lead/kpi/examples/KpiDropdownComponent";

export default {
  name: "KpiView",
  components: {KpiDropdownComponent, KpiSingleComponent},
  setup(){

    const kpis = [
      {
        title: 'Leads in Verteilung',
        kpi: 13,
        interval: 'letzte 24 h',
        trend: '-19,4 %',
        trendDirection: trendDirections.DOWN,
        clickable: true
      },
      {
        title: 'Leads in Bearbeitung',
        kpi: 45,
        interval: '24.-25.07.20',
        trend: '76,4 %',
        trendDirection: trendDirections.UP
      },
      {
        title: 'Leadgeber',
        kpi: 23,
        kpiColor: colors.GRAY,
        interval: '3 T 17 H 53 s',
        trend: '1,4 %',
        trendDirection: trendDirections.UP,
        trendIconColor: colors.RED
      },
      {
        title: 'Leadnehmer',
        kpi: 39,
        interval: '24.-25.07.20',
        trend: '0,0 %',
        trendDirection: trendDirections.FLAT,
        showDropdownMenu: true
      }
    ]

    function onKpiClicked(kpi){
      console.log(kpi)
    }

    return {kpis, onKpiClicked}
  }
}
</script>

<style scoped lang="scss">
  // Reset spacing
  .kpi-single.v-card.v-sheet.mb-2.theme--light {
    margin: 0 !important;
  }
</style>
